import type { SurveyKey } from '../shared/survey';

export function surveyDisplayName(surveyKey: SurveyKey, fallback = ''): string {
  if (surveyKey === 'original') return 'Original Survey';
  if (surveyKey === 'no-mitigation') return 'Alternate Survey';
  if (surveyKey === 'pro-biased') return 'Shortened Survey';
  return fallback;
}
